import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

/**
 * ChartRadioButtonComponent
 * @description Renders radio buttons for filter options
 */
@Component({
  selector: 'app-chart-radio-button-filters',
  templateUrl: './chart-radio-button-filters.component.html',
  styleUrls: ['./chart-radio-button-filters.component.scss']
})
export class ChartRadioButtonFiltersComponent implements OnInit, OnChanges {
  /** Selected filters to show in form */
  @Input() selectedFilters: {};
  /** Filter options available */
  @Input() filterOptions: {};
  /** Configuration for filter options with names and if they should be disabled */
  @Input() config: {names: {}, disabled: {}};
  /** Emitter when filters change (update) */
  @Output() filtersChange = new EventEmitter<any>();
  /** Emitter when Submit button was clicked */
  @Output() submit ?= new EventEmitter<any>();
  /** Emitter when filters are reset */
  @Output() resetFilters = new EventEmitter<any>();
  /** Boolean if options are multi-selection or just one */
  @Input() multiple?: boolean;
  /** Blocks to display */
  blocks: string[] = [];

  /** Empty constructor */
  constructor() { }

  /** Init blocks property */
  ngOnInit() {
    const vm = this;
    this.blocks = Object.keys(this.filterOptions).filter(block => block !== 'date' && vm.filterOptions[block].length > 0);
  }

  /** Called when @Input properties change. If filterOptions change, generate radio-button options */
  ngOnChanges(changes) {
    if (changes.hasOwnProperty('filterOptions')) {
      const vm = this;

      if (this.filterOptions.hasOwnProperty('COLOR_PIEL')) {
        const all = this.filterOptions['COLOR_PIEL'].slice(0, 1);
        const newOrder = this.filterOptions['COLOR_PIEL'].slice(1, this.filterOptions['COLOR_PIEL'].length);

        const intermedio = newOrder.shift();
        newOrder.splice(1, 0, intermedio);
        this.filterOptions['COLOR_PIEL'] = all.concat(newOrder);
      }
      if (this.filterOptions.hasOwnProperty('ESTRATO')) {
        const getItems = [];
        const newOrder = [];
        this.filterOptions['ESTRATO'].forEach(function(es) {
          if (es === 'Todos') {
            getItems.push({ name: es, order: 1});
          } else if (es === 'Alto') {
            getItems.push({ name: es, order: 2 });
          } else if (es === 'Medio alto') {
            getItems.push({ name: es, order: 3 });
          } else if (es === 'Medio bajo') {
            getItems.push({ name: es, order: 4 });
          } else if (es === 'Bajo') {
            getItems.push({ name: es, order: 5 });
          }
        });
        getItems.sort(function(a, b) {
          if (a.order < b.order) {
            return -1;
          } else if (a.order > b.order) {
            return 1;
          } else {
            return 0;
          }
        });
        getItems.forEach(function(oi) { newOrder.push(oi.name); });
        this.filterOptions['ESTRATO'] = newOrder;
      }
      if (this.filterOptions.hasOwnProperty('RANGO_EDAD')) {
        const all = this.filterOptions['RANGO_EDAD'].slice(0, 1);
        const newOrder = this.filterOptions['RANGO_EDAD'].slice(1, this.filterOptions['RANGO_EDAD'].length);

        newOrder.sort(function(a, b) {
          return a.localeCompare(b, undefined, {numeric: true});
        });

        this.filterOptions['RANGO_EDAD'] = all.concat(newOrder);
      }
      this.blocks = Object.keys(this.filterOptions).filter(block => block !== 'date' && vm.filterOptions[block].length > 0);
    }
  }

  /** Emit change of selected filters */
  updateFilters() {
    this.filtersChange.emit(this.selectedFilters);
  }

  /** Emit change of selectedFilters when clicking submit button */
  onSubmit() {
    this.submit.emit(this.selectedFilters);
  }

  /** Check if option should be disabled */
  isOptionDisabled(slug, option) {
    switch (slug) {
      case 'unidad':
        return this.config.disabled && this.config.disabled[slug] ? this.config.disabled[slug][option] : false;
      default:
        return this.config.disabled[slug];
    }
  }

  /** Reset filters. Emit @Output */
  reset($event) {
    // Prevent form submit
    $event.preventDefault();
    $event.stopPropagation();
    this.resetFilters.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/chart-radio-button-filters/chart-radio-button-filters.component.ts